import { pList, rOyakGmCiroBazli, rValue } from '../../../../api/models/.catalog';
import { ActionSubTypes } from '../../../ActionSubTypes';
import Api from '../../../../api/ApiWrapper';
import { IApiAction, IPromiseAction } from '../../../../models/ActionModels';
import ActionFunctions from '../../../core/ActionFunctions';
import { IError } from '../../../../models/StateModels';
import { Collection } from '../../../../models/Collection';

export const action_async_start = (body: pList): IPromiseAction<pList> =>
  ActionFunctions.action_async_start_promise(
    ActionSubTypes.API_OYAKGMCIROBAZLILISTE,
    new Api.Bilgi.OyakGmCiroBazliListe().Request(body),
    false,
    false,
    body
  );

export const action_async_complete = (
  data: rValue<rOyakGmCiroBazli> | null | undefined,
  error: IError | null | undefined
): IApiAction<rOyakGmCiroBazli> =>
  ActionFunctions.action_async_complete_api<rOyakGmCiroBazli>(
    ActionSubTypes.API_OYAKGMCIROBAZLILISTE,
    { Data: new Collection(((data?.Value?.Data as unknown) as any) || []) },
    error
  );
